import { Stack, Typography } from '@mui/material';
import { CustomCheckbox, FormSection } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext, useEffect } from 'react';
import { IndexContext } from '../CaseContext';
import { FormSectionWrapper } from 'Components/FormSectionWrapper';
import { useFormContext, useWatch } from 'react-hook-form';
import { ICaseDetailsInputs } from 'API';

export const ClassifiedDocumentsDeclaration = () => {
  const { index } = useContext(IndexContext);

  const {
    formState: { errors },
  } = useFormContext<ICaseDetailsInputs>();

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);
  const isDesktop = useIsDesktop();

  const baseName = `caseDetails.${index}`;

  useWatch({
    name: `${baseName}.isClassifiedDocsApproved`,
  });

  useEffect(() => {
    if (errors.caseDetails && errors.caseDetails[0]?.isClassifiedDocsApproved)
      window.scroll({ behavior: 'smooth', top: 0 });
  }, [errors.caseDetails]);

  return (
    <FormSectionWrapper>
      <FormSection grouped id={dictionary.classifiedDocDeclaration}>
        <Typography
          fontSize={isDesktop ? '18px !important' : '16px !important'}
          sx={{ fontWeight: 'bold' }}
        >
          {dictionary.classifiedDocDeclaration}
        </Typography>
        <Typography fontSize={isDesktop ? undefined : '14px'}>
          {dictionary.classifiedDocDeclarationAnnouncement}
        </Typography>
        <Stack
          sx={{
            bgcolor: '#F2F9FF',
            p: '18px',
            borderRadius: '12px',
            gap: '16px',
            mb: '24px',
          }}
        >
          <Typography fontSize={isDesktop ? undefined : '14px'}>
            {dictionary.classifiedDocDeclarationDetail}
          </Typography>
          <CustomCheckbox
            name={`${baseName}.isClassifiedDocsApproved`}
            label={dictionary.classifiedDocDeclarationCheckbox}
            sxCheckbox={{
              '& svg path': {
                backgroundColor: 'red',
              },
            }}
          />
        </Stack>
      </FormSection>
    </FormSectionWrapper>
  );
};
